import { render } from "./GroupAll.vue?vue&type=template&id=66a318f8"
import script from "./GroupAll.vue?vue&type=script&lang=js"
export * from "./GroupAll.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__